import type { LandingPageContent } from '../types'

export const OFERTA_FOTOWOLTAICZNA_BEZ_TELEFONU: LandingPageContent = {
  slug: 'oferta-fotowoltaiczna-bez-telefonu',
  lang: 'pl',
  topicId: 'photovoltaik-ohne-telefonnummer',
  title: 'Oferty fotowoltaiczne bez telefonu – w 100% anonimowo',
  metaDescription:
    'Poproś o oferty fotowoltaiczne bez podawania numeru telefonu czy e-maila: anonimowe ' +
    'zapytanie, żadnych telefonów od handlowców, kontakt dopiero po Twojej zgodzie. Bezpłatnie.',
  keywords: [
    'fotowoltaika bez telefonu',
    'oferta fotowoltaiczna bez e-maila',
    'anonimowe zapytanie fotowoltaiczne',
    'porównanie ofert solarnych bez telefonów',
    'fotowoltaika bez rejestracji',
    'jak pozbyć się handlowców fotowoltaika',
    'unikać sprzedaży door-to-door fotowoltaika',
  ],
  eyebrow: 'Anonimowo i bez telefonów od handlowców',
  h1: 'Oferty fotowoltaiczne bez podawania numeru telefonu czy e-maila',
  intro:
    'Na większości portali porównawczych numer telefonu lub e-mail są obowiązkowe, zanim w ogóle ' +
    'zobaczysz jakąkolwiek ofertę - a dokładnie te dane trafiają potem jednocześnie do kilku firm. ' +
    'W Roofora całe zapytanie działa bez jednego i drugiego: porównujesz oferty fotowoltaiczne bez ' +
    'ryzyka, że jakakolwiek firma zadzwoni, zanim wyraźnie na to pozwolisz.',
  sections: [
    { type: 'heading', text: 'Dlaczego telefon i e-mail są problemem na innych portalach' },
    {
      type: 'paragraph',
      text:
        'Gdy tylko zapytanie z prawdziwymi danymi kontaktowymi zostanie opublikowane, tracisz ' +
        'kontrolę nad tym, kto je widzi. Wiele portali sprzedaje to samo zapytanie kilku firmom ' +
        'jednocześnie - efektem są telefony od handlowców, z którymi nigdy się nie kontaktowałeś, ' +
        'czasem już kilka minut po wysłaniu.',
    },
    { type: 'heading', text: 'Tak działa całkowicie anonimowe zapytanie w Roofora' },
    {
      type: 'paragraph',
      text:
        'Twoje konto powstaje tylko z wybranej przez Ciebie nazwy użytkownika i hasła, plus kodu ' +
        'odzyskiwania do resetu - bez adresu e-mail, bez numeru telefonu. Twoje zapytanie (zdjęcia ' +
        'dachu, zdjęcie rozdzielnicy, orientacja, zużycie) publikowane jest anonimowo: firmy widzą ' +
        'okolicę i dane techniczne, ale nie Twoje dane kontaktowe.',
    },
    { type: 'heading', text: 'Kiedy firma rzemieślnicza może w ogóle się z Tobą skontaktować' },
    {
      type: 'paragraph',
      text:
        'Firmy mogą złożyć niewiążącą ofertę lub wysłać zapytanie o kontakt - obie rzeczy dostajesz ' +
        'wyłącznie jako anonimowe powiadomienie. Dopiero gdy sam aktywnie i pojedynczo udostępnisz ' +
        'kontakt konkretnej firmie, otrzymuje ona Twój numer telefonu i e-mail. Bez zbiorowej ' +
        'zgody, bez automatyzmów.',
    },
    {
      type: 'list',
      items: [
        'Żaden telefon nie jest możliwy przy rejestracji ani przy złożeniu oferty',
        'Twoje dane nie są odsprzedawane osobom trzecim',
        'Sam ustalasz limit, ile firm może maksymalnie otrzymać Twoje dane kontaktowe',
        'Każda zgoda dotyczy tylko jednej, wybranej przez Ciebie firmy',
        'Oferty porównujesz spokojnie, bez presji wynikającej z telefonów',
      ],
    },
    { type: 'heading', text: 'Dla kogo anonimowe zapytanie jest szczególnie przydatne' },
    {
      type: 'paragraph',
      text:
        'Jeśli po jednym zapytaniu o ofertę przez kilka dni dzwoniły do Ciebie różne firmy, znasz ' +
        'ten problem. Anonimowe zapytanie eliminuje go całkowicie: pozostajesz niedostępny dla ' +
        'telefonów handlowych, dopóki sam nie zrobisz pierwszego kroku.',
    },
  ],
  faq: [
    {
      q: 'Czy naprawdę nie muszę podawać numeru telefonu?',
      a: 'Nie. Do założenia konta klienta nie jest potrzebny ani telefon, ani e-mail - rejestrujesz się jedynie za pomocą nazwy użytkownika i hasła.',
    },
    {
      q: 'Jak w takim razie się zarejestrować albo zresetować hasło?',
      a: 'Przy rejestracji otrzymujesz kod odzyskiwania, dzięki któremu możesz później zresetować hasło - bez skrzynki e-mail czy SMS-a.',
    },
    {
      q: 'A jeśli jednak chcę, żeby skontaktowała się ze mną konkretna firma?',
      a: 'W każdej chwili możesz udostępnić kontakt jednej, wybranej firmie - dopiero wtedy otrzymuje ona Twój numer telefonu i e-mail, wszystkie pozostałe nadal nie mają do nich dostępu.',
    },
    {
      q: 'Jak pozbyć się telefonów od handlowców innych firm fotowoltaicznych?',
      a: 'W Roofora ten problem w ogóle nie powstaje: Twoje dane kontaktowe trafiają tylko do firm, które sam indywidualnie zaakceptujesz. Przy już trwających niechcianych telefonach od innych firm pomaga nieprzekazywanie wrażliwych danych przez telefon i w razie wątpliwości rozłączenie się.',
    },
    {
      q: 'Jak uniknąć sprzedaży door-to-door przy fotowoltaice?',
      a: 'Najbezpieczniej jest od razu zbierać oferty przez anonimowe zapytanie zamiast przez akwizytorów przy drzwiach lub przez telefon - dzięki temu tylko Ty decydujesz, która firma w ogóle może się z Tobą skontaktować.',
    },
  ],
  primaryCta: { label: 'Poproś teraz o anonimową ofertę', action: 'customer' },
  secondaryCta: {
    label: 'Jak działa porównanie ofert',
    action: 'link',
    href: '/porownaj-oferty-fotowoltaiczne',
  },
  relatedLinks: [
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
    { label: 'Ile kosztuje instalacja fotowoltaiczna?', href: '/koszt-instalacji-fotowoltaicznej' },
    { label: 'Złóż zapytanie fotowoltaiczne krok po kroku', href: '/zlozyc-zapytanie-fotowoltaiczne' },
  ],
}
